import { render, staticRenderFns } from "./ReferencesAvb.vue?vue&type=template&id=57410e2e"
import script from "./ReferencesAvb.vue?vue&type=script&lang=js"
export * from "./ReferencesAvb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports